var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class StorageProperties {
  constructor() {
    /** Total referral count, incremented on each referral in `_populateNotificationPayload`. */
    __publicField(this, "absoluteSequence", 0);
    __publicField(this, "abTests", {});
    /** First entry user properties, set in `sendEntryFinalAnalytics` on first entry. */
    __publicField(this, "analytics", {});
    __publicField(this, "botSubscriptionViewCount", 0);
    /**
     * LINE policy:
     * - max 50 friends can be invited per day
     * - max 1000 invites per day
     * - the day is reset at midnight
     */
    __publicField(this, "dailyInvites", { count: 0, invitees: {}, lastInviteDay: 0 });
    /** Demographic analytic properties, accessible through `Platform.getDemographics`. */
    __publicField(this, "demographics", {});
    __publicField(this, "entry", {
      first: 1545231968498,
      last: 0,
      lastAdEntry: 0,
      lastNativeAndroidEntry: 0,
      lastNativeIOSEntry: 0,
      lastResurrected: 0,
      count: 0
    });
    /** Per-feature referral counts, incremented on each referral in `_populateNotificationPayload`. */
    __publicField(this, "featureAbsoluteSequences", {});
    /** Ad analytics state. */
    __publicField(this, "gcn", { adsWatched: 0 });
    /** Previous entry's payload, used to track consecutive entries from the same entry point. */
    __publicField(this, "previousPayload");
    __publicField(this, "settings", { bgmVolume: 0.5, sfxVolume: 0.5 });
    /** Properties related to Terms of Service. */
    __publicField(this, "tos", {});
    /** The total number of times this user has been "pinched" (i.e. all of a consumable resource has run out). */
    __publicField(this, "trackPinchAllTimeCount", 0);
    /** The number of times this user has been "pinched" per resource (i.e. all of a given consumable resource has run out). */
    __publicField(this, "trackPinchAllTimeCounts", {});
  }
}
class PlatformStorage extends StorageProperties {
  constructor(_platform) {
    super();
    __publicField(this, "_loadPromise", null);
    __publicField(this, "_saveHandle", null);
    __publicField(this, "_savePromise", null);
    __publicField(this, "_storageKey", null);
    __publicField(this, "adapter");
    __publicField(this, "savedProperties");
    this._platform = _platform;
    this.savedProperties = JSON.stringify(this.getStorageProperties());
  }
  /** @returns `true` if storage adapter is configured. */
  hasAdapter() {
    return !!this.adapter;
  }
  getStorageProperties() {
    const storageProperties = new StorageProperties();
    for (const key in storageProperties) {
      storageProperties[key] = this[key];
    }
    return storageProperties;
  }
  /** Update storage property values. */
  assign(setterFn) {
    setterFn(this);
    void this.save();
  }
  load() {
    if (this._loadPromise != null) {
      return this._loadPromise;
    }
    this._storageKey = this._platform._gameConfig.appID + ".models";
    const loadPlatformStorage = () => this._platform.getDataAsync([this._storageKey]).then((response) => response == null ? void 0 : response[this._storageKey]);
    this._loadPromise = (this.adapter ? this.adapter.load().then((dataFromAdapter) => {
      if (!dataFromAdapter && this.adapter.fallbackToPlatformStorage === true) {
        return loadPlatformStorage();
      }
      return dataFromAdapter;
    }) : loadPlatformStorage()).then((data) => {
      if (!data) {
        return;
      }
      assignObjectNested(this, data);
    }).catch((e) => {
      console.error("Failed to load platform data:", e);
    });
    return this._loadPromise;
  }
  save() {
    if (this._loadPromise === null) {
      void this.load();
    }
    if (this._saveHandle) {
      return this._savePromise;
    }
    let savePromiseResolve = null;
    this._savePromise = new Promise((resolve) => {
      savePromiseResolve = resolve;
    });
    this._saveHandle = window.setTimeout(() => {
      this._saveHandle = null;
      void this._loadPromise.then(async () => {
        const newStorageProperties = this.getStorageProperties();
        const newSavedProperties = JSON.stringify(newStorageProperties);
        const isChanged = newSavedProperties !== this.savedProperties;
        if (!isChanged) {
          return;
        }
        await (this.adapter ? this.adapter.save(newStorageProperties) : this._platform.setDataAsync({
          [this._storageKey]: newStorageProperties
        }));
        this.savedProperties = newSavedProperties;
      }).then(() => {
        savePromiseResolve();
      });
    }, 0);
    return this._savePromise;
  }
  /**
   * Set custom storage endpoint to be used instead of the default platform storage.
   *
   * **Must be called** before `GCInstant.loadStorage` and `GCInstant.startGameAsync`.
   */
  setStorageAdapter(adapter, opts) {
    this.adapter = {
      ...adapter,
      fallbackToPlatformStorage: !!(opts == null ? void 0 : opts.fallbackToPlatformStorage)
    };
  }
}
function assignObjectNested(obj, newProperties) {
  for (const k in newProperties) {
    const key = k;
    const value = newProperties[key];
    if (value && typeof value === "object" && obj[key]) {
      assignObjectNested(obj[key], value);
    } else {
      obj[key] = value;
    }
  }
}
const PlatformStorage$1 = PlatformStorage;
export {
  PlatformStorage,
  StorageProperties,
  PlatformStorage$1 as default
};
